export const LABEL_CATEGORY = 'categories';
export const TEXTURE_CATEGORY_FILTER_ID = 4;
export const TYPE_TEXTURE = 2;

export const MODE_EDIT = 'edit';
export const MODE_UPLOAD = 'upload';
export const MODE_MOVE_TO_TEXTURES = 'move-to-textures';
const { REACT_APP_VERSION } = process.env;

export const UNITY_REF = {
  loaderUrl: `/Build/texture/TexturePreviewBuild.loader.js?version=${MODE_MOVE_TO_TEXTURES}`,
  dataUrl: `/Build/texture/TexturePreviewBuild.data?version=${MODE_MOVE_TO_TEXTURES}`,
  frameworkUrl: `/Build/texture/TexturePreviewBuild.framework.js?version=${MODE_MOVE_TO_TEXTURES}`,
  codeUrl: `/Build/texture/TexturePreviewBuild.wasm?version=${MODE_MOVE_TO_TEXTURES}`,
};

export const MAX_UPLOAD_WIDTH_PIXELS = 16384;
export const MAX_UPLOAD_HEIGHT_PIXELS = 16384;
export const DEFAULT_DPI = 72;

export const NON_MAP_FILTER_ID = 1520;
